import type { EstadoCierre } from "./api";

/**
 * Los pasos del periodo como los vive la oficina. Los 10 estados del cierre
 * se agrupan en seis pasos: la barra muestra dónde está el periodo y cuál es
 * el siguiente movimiento, sin exponer la máquina de estados.
 */
export const PASOS_PERIODO = [
  "Abrir",
  "Revisar lecturas",
  "Calcular",
  "Revisar y emitir",
  "Imprimir y repartir",
  "Cerrar",
] as const;

/**
 * Índice del paso en curso (0-based). `PASOS_PERIODO.length` = todo hecho.
 * El paso 0 (Abrir) ya está hecho apenas existe el cierre.
 */
export function pasoActual(estado: EstadoCierre): number {
  switch (estado) {
    case "ABIERTO":
    case "EN_PREVALIDACION":
    case "BLOQUEADO":
      return 1;
    case "PREVALIDADO":
    case "EN_CALCULO":
      return 2;
    case "CALCULADO":
    case "EN_FACTURACION":
      return 3;
    case "FACTURADO":
    case "HOLD":
      return 4;
    case "CERRADO":
      return PASOS_PERIODO.length;
  }
}
